export default __webpack_public_path__ + "static/media/prebuiltIco.bc47256d.svg";